(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novenu-global"]) return;
  try {
    
  (() => {
    let stickyObserver;
    let cartBubbleObserver;
    let variantChangeUnsubscriber;

    function initVariantChangeSync() {
      variantChangeUnsubscriber?.();
      variantChangeUnsubscriber = undefined;
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
        updateSticky();
      });
    }

    function closeMenu(focusToggle = false) {
      const toggle = document.querySelector('.novenu-menu-toggle');
      const menu = document.getElementById('novenu-mobile-menu');
      if (!toggle || !menu) return;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.dataset.state = 'closed';
      menu.dataset.open = 'false';
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('novenu-menu-open');
      if (focusToggle) toggle.focus();
    }

    function initMenu() {
      const toggle = document.querySelector('.novenu-menu-toggle');
      const menu = document.getElementById('novenu-mobile-menu');
      if (!toggle || !menu || toggle.dataset.novenuBound === 'true') return;
      toggle.dataset.novenuBound = 'true';
      toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
        if (!shouldOpen) {
          closeMenu();
          return;
        }
        toggle.setAttribute('aria-expanded', 'true');
        toggle.dataset.state = 'open';
        menu.dataset.open = 'true';
        menu.setAttribute('aria-hidden', 'false');
        document.body.classList.add('novenu-menu-open');
        menu.querySelector('a')?.focus();
      });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => closeMenu()));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu(true);
      });
      document.addEventListener('click', (event) => {
        if (!menu.contains(event.target) && !toggle.contains(event.target)) closeMenu();
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 990) closeMenu();
      });
    }

    function selectedOptions() {
      const selectValues = [...document.querySelectorAll('variant-selects select')]
        .map((select) => select.value.trim())
        .filter(Boolean);
      const radioValues = [
        ...document.querySelectorAll(
          'variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked'
        ),
      ]
        .map((input) => input.value.trim())
        .filter(Boolean);
      return (selectValues.length ? selectValues : radioValues)
        .slice(0, 2)
        .join(' · ');
    }

    function purchaseOverlayOpen() {
      return Boolean(
        document.querySelector('[data-novenu-size-dialog][open], cart-drawer.active, cart-notification.active, .drawer.active')
      );
    }

    function setStickyHidden(sticky, hidden) {
      sticky.hidden = hidden;
      document.body.classList.toggle('novenu-sticky-visible', !hidden);
    }

    function updateSticky() {
      const sticky = document.querySelector('[data-novenu-sticky-buy]');
      if (!sticky) return;
      const selection = sticky.querySelector('[data-novenu-sticky-selection]');
      if (selection) selection.textContent = selectedOptions();
      const visiblePrice = document.querySelector(
        'product-info .price--on-sale .price__sale .price-item--sale'
      ) || document.querySelector(
        'product-info .price:not(.price--on-sale) .price__regular .price-item--regular'
      );
      const stickyPrice = sticky.querySelector('[data-novenu-sticky-price]');
      if (visiblePrice && stickyPrice) stickyPrice.textContent = visiblePrice.textContent.trim();
      const error = document.querySelector('product-info .product-form__error-message-wrapper:not([hidden])');
      const submit = document.querySelector('product-info .product-form__submit');
      if (error || !submit || submit.disabled || purchaseOverlayOpen() || window.innerWidth >= 750) {
        setStickyHidden(sticky, true);
      }
    }

    function initSticky() {
      const sticky = document.querySelector('[data-novenu-sticky-buy]');
      const submit = document.querySelector('product-info .product-form__submit');
      if (!sticky || !submit) return;
      const stickySubmit = sticky.querySelector('[data-novenu-sticky-submit]');
      if (stickySubmit && stickySubmit.dataset.novenuBound !== 'true') {
        stickySubmit.dataset.novenuBound = 'true';
        stickySubmit.addEventListener('click', () => {
          const currentSubmit = document.querySelector('product-info .product-form__submit');
          if (!currentSubmit || currentSubmit.disabled) {
            document.querySelector('product-info')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          currentSubmit.click();
        });
      }
      if (stickyObserver) stickyObserver.disconnect();
      stickyObserver = new IntersectionObserver(([entry]) => {
        const error = document.querySelector('product-info .product-form__error-message-wrapper:not([hidden])');
        setStickyHidden(
          sticky,
          entry.isIntersecting
            || Boolean(error)
            || submit.disabled
            || purchaseOverlayOpen()
            || window.innerWidth >= 750
        );
        updateSticky();
      }, { threshold: 0.2 });
      stickyObserver.observe(submit);
      updateSticky();
    }

    function initSizeGuide() {
      const dialog = document.querySelector('[data-novenu-size-dialog]');
      if (!dialog || dialog.dataset.novenuBound === 'true') return;
      dialog.dataset.novenuBound = 'true';
      document.querySelectorAll('[data-open-size-guide]').forEach((button) => {
        button.addEventListener('click', () => {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          updateSticky();
        });
      });
      dialog.querySelector('[data-novenu-size-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const bounds = dialog.getBoundingClientRect();
        const outside = event.clientX < bounds.left
          || event.clientX > bounds.right
          || event.clientY < bounds.top
          || event.clientY > bounds.bottom;
        if (outside) dialog.close();
      });
      dialog.addEventListener('close', () => window.setTimeout(initSticky, 0));
    }

    function syncCartBubbleLabel() {
      const cartLink = document.getElementById('cart-icon-bubble');
      if (!cartLink) return;
      const countNode = cartLink.querySelector(
        '.cart-count-bubble span[aria-hidden="true"], .novenu-site-header__cart-count'
      );
      const count = Number.parseInt(countNode?.textContent || '0', 10);
      const template = count === 1
        ? cartLink.dataset.novenuCartLabelOne
        : cartLink.dataset.novenuCartLabelOther;
      if (template) cartLink.setAttribute('aria-label', template.replace('__COUNT__', String(count)));
    }

    function initCartBubble() {
      const cartLink = document.getElementById('cart-icon-bubble');
      if (!cartLink) return;
      syncCartBubbleLabel();
      if (cartBubbleObserver) cartBubbleObserver.disconnect();
      cartBubbleObserver = new MutationObserver(syncCartBubbleLabel);
      cartBubbleObserver.observe(cartLink, { childList: true, subtree: true, characterData: true });
    }

    function init() {
      initVariantChangeSync();
      initMenu();
      initSizeGuide();
      initSticky();
      initCartBubble();
      updateSticky();
    }

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init, { once: true })
      : init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('change', (event) => {
      if (event.target.matches('input, select')) window.setTimeout(updateSticky, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
